import { Form, FormItemProps,Input as AntdInput } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import type { Rule } from "antd/es/form";
import classNames from "clsx";
import * as React from "react";

import { SizeEnum } from "@/types";
import { REQUIRED_VALIDATION_MESSAGE } from "@/utils/constant";

interface InputProps extends FormItemProps {
  name: string;
  label?: string;
  placeholder: string;
  size?: SizeEnum;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  allowClear?: boolean;
  isSeperator?: boolean;
  type?: any
  onChangeListener?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Input = ({
  name,
  label,
  placeholder,
  size = SizeEnum.large,
  required = false,
  allowClear = false,
  isSeperator = false,
  readOnly = false,
  onChangeListener,
  rules = [],
  type,
  ...rest
}: InputProps) => {
  const getRules = (): Rule[] => {
    return [...rules, { required, message: REQUIRED_VALIDATION_MESSAGE }];
  };

  return (
    <div
      className={classNames(
        "custom_form_comp_wrapper",
        rest?.hidden && "h-0 overflow-hidden",
        isSeperator && "flex items-center gap-x-2"
      )}
    >
      {label && (
        <label
          htmlFor={name}
          className={classNames(
            "block text-primary-0",
            isSeperator ? "mb-6" : "mb-2"
          )}
        >
          {label}
        </label>
      )}
      {isSeperator && (
        <div className="mb-6 flex-[1] basis-40 border border-dashed border-disabled" />
      )}
      <div className={classNames(isSeperator && "basis-[288px]")}>
        <Form.Item name={name} rules={getRules()} {...rest}>
          <AntdInput
            size={size as SizeType}
            allowClear={allowClear}
            placeholder={placeholder}
            disabled={rest?.disabled}
            readOnly={readOnly}
            onChange={onChangeListener}
            type={type}
            className={classNames(
              "bg-neutral-150 text-sm placeholder:text-[#62748E80]/80 border-[#F8FAFC] focus:border-primary-500",
              readOnly && "cursor-default select-text"
            )}
          />
        </Form.Item>
      </div>
    </div>
  );
};
